import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";

import "ui-components/status-badge/status-badge";

import { t } from "../../translations/i18n";
import { styles } from "./message-status-badge.css";

export type MessageStatus = "draft" | "scheduled" | "sending" | "sent" | "failed" | "archived";

const labelKey: Record<MessageStatus, Parameters<typeof t>[0]> = {
  draft: "messagesPage.draft",
  scheduled: "messagesPage.scheduled",
  sending: "messagesPage.sending",
  sent: "messagesPage.sent",
  failed: "messagesPage.failed",
  archived: "messagesPage.archived",
};

@customElement("message-status-badge")
export class MessageStatusBadge extends LitElement {
  static override styles = [styles];

  @property({ type: String })
  status: MessageStatus = "draft";

  override render() {
    return html`
      <status-badge variant="event">
        <span slot="icon" class="status-dot ${this.status}"></span>
        ${t(labelKey[this.status])}
      </status-badge>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "message-status-badge": MessageStatusBadge;
  }
}
